import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// Returns an optimized thumbnail URL for images served from our object storage.
// External URLs (e.g. unsplash) are returned unchanged.
export function thumb(url, w = 600) {
  if (!url || typeof url !== "string") return url;
  if (url.includes("/api/files/")) {
    return url + (url.includes("?") ? "&" : "?") + "w=" + w;
  }
  return url;
}
